var map = {
	"./cash-icon-home-mobile.webp": 1669,
	"./cashout-icon-home-mobile.webp": 1670,
	"./transfer-icon-home-mobile.webp": 1671,
	"./vip-icon-home-mobile.webp": 1672,
	"./wallet-icon-home-mobile.webp": 1673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;